import { useRuntimeConfig } from '#imports'

import type { Market } from '@backmarket/http-api'
import type { RouteRecordRaw } from 'vue-router'

export const ABOUT_US = 'about_us'

export default ({ market }: { market: Market }): RouteRecordRaw[] => {
  const { FF_ENABLED_COUNTRIES_FRONT_APPS_ROUTE_ABOUT_US } =
    useRuntimeConfig().public

  const isFrontAppsRouteOpenedInCountry = (
    FF_ENABLED_COUNTRIES_FRONT_APPS_ROUTE_ABOUT_US as string
  ).includes(market.countryCode)

  return [
    {
      path: '/:locale/about-us',
      name: ABOUT_US,
      component: () => import('./AboutUs.vue'),
      meta: {
        disableClientSideNavigation: () => !isFrontAppsRouteOpenedInCountry,
      },
    },
  ]
}
